<template>
  <main class="main-content">
    <div class="card">
      <div class="card-body" v-if="installer!=null">
        <div class="card-title">
           <div class="d-flex justify-content-end my-2 my-1 d-print-none">
          <a
          @click="printReport"
          class="btn btn-success m-l-5 my-1">
            <i class="fa fa-print m-r-5"></i> چاپ
          </a>
        </div>
          <div class="d-flex justify-content-center">
             <span class="font-size-25">وضعیت کارکرد پیمانکاران جز</span>
          </div>
          <hr>
          <div class="d-flex justify-content-between px-2">
            <span class="font-size-15">
              <span>
                گزارش جزئیات پروژه نصاب:
              </span>
              <span>
                {{installer.name}}
              </span>
              <span>
                با کد ملی:
              </span>
              <span>
                {{installer.identfication}}
              </span>
            </span>
            <span class="font-size-15">
              <span>تاریخ: </span>
              <span>{{now}}</span>
            </span>
          </div>
          <hr>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th style="width:5%">ردیف</th>
                <th style="width:10%">کد پروژه</th>
                <th style="width:10%">عنوان پروژه</th>
                <th style="width:10%">متریال</th>
                <th v-for="(material, key , index) in materials" :key="index" :style="{ width: material['width']+'%' }">{{material['name']}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(attribute , index) in installer.attributes" :key="index">
                <td>{{index+1}}</td>
                <td>{{attribute.project.code}}</td>
                <td>{{attribute.project.name}}</td>
                <td>{{attribute.material.name}}</td>
                <td v-for="(material, key , index) in materials" :key="index">
                  <div v-if="attribute.detail">
                    <div v-if="key!='description'">
                      {{new Intl.NumberFormat().format(attribute.detail[key])}}
                    </div>
                    <div v-else>
                      {{attribute.detail[key]}}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>جمع کل</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  {{new Intl.NumberFormat().format(sum)}}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr>
        <div class="d-flex">
          <div class="col-6">
            <span class="font-size-20">امضای مدیریت:</span>
          </div>
          <div class="col-6">
            <span class="font-size-20">امضای ناظر:</span>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'installerReport',
  data () {
    return {
      installer: null,
      now: null,
      materials: null,
      sum: null
    }
  },
  beforeCreate () {
    if (this.$route.params.pdf) {
      this.$send.submit('post', 'api/installer/report/' + this.$route.params.pdf + '/print')
        .then(response => {
          console.log(response)
          this.installer = response.installer
          this.now = response.now
          this.materials = response.materials
          this.sum = response.sum
        })
    } else {
      this.$send.submit('post', 'api/installer/report/' + this.$route.params.id)
        .then(response => {
          this.installer = response.installer
          this.now = response.now
          this.materials = response.materials
          this.sum = response.sum
        })
    }
  },
  methods: {
    printReport () {
      window.print()
    }
  }

}
</script>

<style>

</style>
